import * as type from '../type';
import * as sel from '../../api/sel';

const state = {}

const actions = {
    getBankList({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            sel.getBankList().then(res => {
                if (res.data.res_code == 1) {
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg);
                }
            }).catch(error => {
                console.error(error);
                reject();
            })
        })
    }
}

const mutations = {}

export default {
    state,
    actions,
    mutations
}